/* jshint esversion: 6 */
/* jshint ignore:start */
import { useCallback, useContext, useEffect, useState } from "react";
import { GoSearch } from "react-icons/go";
import { MyContext } from "../../Context/MyProvider";
import axios from "axios";
import { GrLocation } from "react-icons/gr";
import { LuCalendar1 } from "react-icons/lu";
import { FiBell, FiHeadphones, FiMapPin, FiPlus, FiRefreshCcw, FiSearch, FiShield, FiStar } from "react-icons/fi";
import { HiOutlineFilm, HiOutlineGift, HiOutlineHome } from "react-icons/hi2";
import { MdOutlineAccountBalanceWallet, MdOutlineApps, MdOutlineEvent, MdOutlineLocalOffer, MdOutlinePayments, MdOutlinePhoneAndroid, MdOutlineShoppingBag, MdOutlineSportsCricket } from "react-icons/md";
import { BsController, BsQrCodeScan } from "react-icons/bs";
import Slider from "react-slick";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { FaBriefcase, FaHeart, FaTicketAlt, FaWpforms } from "react-icons/fa";
import { showTost } from "../../showTost";
import Loading from "../../Loading";
import { Link, useNavigate } from "react-router-dom";
import author1 from "../../Images/author-1.png";
import author2 from "../../Images/author-2.png";
import author3 from "../../Images/author-3.png";
import author4 from "../../Images/author-4.png";
import author5 from "../../Images/author-5.png";
import fireimg from "../../Images/fire.png";
import pinimg from "../../Images/pin.png";
import calendarimg from "../../Images/calendar.png";
import deadlineimg from "../../Images/deadline.png";
import sharing from "../../Images/sharing.png";
import { useTranslation } from "react-i18next";
import noImage from "../../Images/no_image.png";
import selfhost from "../../Images/selfhost.png";
import logoWithName from "../../Images/logowithname.png";
import DesktopUserChip from "./DesktopUserChip";

/* ================= STATIC LOCATION (iShivax) ================= */
const STATIC_LOCATION = {
    lat: 26.9124,
    long: 75.7873,
};

const DESKTOP_EXPLORE_FALLBACK = [
    { title: "Movies & Videos", subtitle: "Watch Now", icon: HiOutlineFilm, tone: "purple" },
    { title: "Events & Tickets", subtitle: "Book Now", icon: MdOutlineEvent, tone: "pink" },
    { title: "Sports", subtitle: "Live Scores & More", icon: MdOutlineSportsCricket, tone: "green" },
    { title: "Games Mode", subtitle: "Play Now", icon: BsController, tone: "blue" },
    { title: "Eleven11 Cart", subtitle: "Shop Now", icon: MdOutlineShoppingBag, tone: "gold" },
    { title: "Services", subtitle: "Explore", icon: MdOutlineApps, tone: "teal" },
    { title: "Deals & Offers", subtitle: "View Deals", icon: MdOutlineLocalOffer, tone: "red" },
    { title: "Nabi VIP", subtitle: "Explore", icon: HiOutlineGift, tone: "violet" },
];

const DESKTOP_OFFERS_FALLBACK = [
    { title: "Flat 20% OFF", subtitle: "On Movie Tickets", code: "TP20", action: "Book Now", tone: "magenta" },
    { title: "Up to Rs100 OFF", subtitle: "On Event Tickets", code: "SV100", action: "Grab Now", tone: "green" },
    { title: "Rs25 Cashback", subtitle: "On Min. Rs200 UPI Txn", code: "ANNA25", action: "Pay Now", tone: "gold" },
    { title: "Up to 30% OFF", subtitle: "On Grocery & More", code: "CART30", action: "Shop Now", tone: "cyan" },
    { title: "20% OFF", subtitle: "On Home Services", code: "PX20", action: "Book Now", tone: "violet" },
];

const DESKTOP_EVENTS_FALLBACK = [
    { event_title: "Arijit Singh Live in Concert", event_place_name: "Nehru Stadium, Delhi", event_sdate: "25 May, 7:30 PM", type: "LIVE CONCERT", image: noImage },
    { event_title: "Furiosa: A Mad Max Saga", event_place_name: "PVR Phoenix Mall", event_sdate: "24 May, 9:45 PM", type: "MOVIE", image: noImage },
    { event_title: "RCB vs CSK IPL 2024", event_place_name: "M. Chinnaswamy, Bengaluru", event_sdate: "26 May, 7:30 PM", type: "SPORTS", image: noImage },
    { event_title: "Zakir Khan Haq Se Single", event_place_name: "Talkatora Indoor Stadium", event_sdate: "26 May, 8:00 PM", type: "COMEDY", image: noImage },
    { event_title: "The Lion King Musical", event_place_name: "Nita Mukesh Ambani Theatre", event_sdate: "1 Jun, 6:30 PM", type: "PLAY", image: noImage },
];

const DESKTOP_PRODUCTS_FALLBACK = [
    { name: "Amul Taaza", unit: "1 L", unit_price: 56, image: noImage },
    { name: "Aashirvaad Atta", unit: "5 kg", unit_price: 249, image: noImage },
    { name: "Fortune Sunflower Oil", unit: "1 L", unit_price: 139, image: noImage },
    { name: "Lay's Classic", unit: "52 g", unit_price: 20, image: noImage },
    { name: "Surf Excel Matic", unit: "2 kg", unit_price: 219, image: noImage },
    { name: "Colgate Strong Teeth", unit: "200 g", unit_price: 89, image: noImage },
];

const DESKTOP_VIDEOS_FALLBACK = [
    { title: "Kalki 2898 AD", subtitle: "Official Trailer", time: "2:45" },
    { title: "YBL T20 League", subtitle: "Highlights", time: "8:12" },
    { title: "Pushpa 2 - The Rule", subtitle: "Official Teaser", time: "3:18" },
    { title: "Crew", subtitle: "Best Comedy Scene", time: "4:36" },
    { title: "Amaran", subtitle: "Official Trailer", time: "4:36" },
];

const DESKTOP_BANNER_FALLBACK = [
    { type: "promo", id: "weekend-bonanza" },
    { type: "promo", id: "weekend-bonanza-2" },
    { type: "promo", id: "weekend-bonanza-3" },
];

const NextArrow = ({ onClick }) => {
    return (
        <button className="custom-arrow next" onClick={onClick}>
            <FaArrowRightLong />
        </button>
    );
};

const PrevArrow = ({ onClick }) => {
    return (
        <button className="custom-arrow prev" onClick={onClick}>
            <FaArrowLeftLong />
        </button>
    );
};

const Dashboard = () => {
    const { t } = useTranslation();

    const { BaseUrl, setIsLoginShow } = useContext(MyContext);
    const [input, setInput] = useState();
    const [searchList, setSearchList] = useState([]);
    const [location, setLocation] = useState({ lat: null, long: null });
    const [apiRespData, setApiRespData] = useState();
    const [loading, setLoading] = useState(true);
    const [sliderKey, setSliderKey] = useState(0);
    const [data, setData] = useState([]);
    const [products, setProducts] = useState([]);
    const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);
    const [activeDesktopEventTab, setActiveDesktopEventTab] = useState("all");


    const navoigate = useNavigate();

    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 1,
        initialSlide: 0,
        adaptiveHeight: true,
        swipeToSlide: true,
        touchMove: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1305,
                settings: { slidesToShow: 6 }
            },
            {
                breakpoint: 1030,
                settings: { slidesToShow: 5 }
            },
            {
                breakpoint: 770,
                settings: { slidesToShow: 4 }
            },
            {
                breakpoint: 580,
                settings: {
                    slidesToShow: 2,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 430,
                settings: {
                    slidesToShow: 2,
                    initialSlide: 0
                }
            },
            {
                breakpoint: 325,
                settings: {
                    slidesToShow: 1,
                    initialSlide: 0
                }
            }
        ]
    };

    useEffect(() => {
        const timer = setTimeout(() => {
            setSliderKey(prev => prev + 1);
        }, 200); // mobile reflow fix

        return () => clearTimeout(timer);
    }, []);

    const settings2 = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            { breakpoint: 1400, settings: { slidesToShow: 3, slidesToScroll: 1 }, },
            { breakpoint: 1030, settings: { slidesToShow: 3, slidesToScroll: 1 }, },
            { breakpoint: 995, settings: { slidesToShow: 2, slidesToScroll: 1 }, },
            { breakpoint: 580, settings: { slidesToShow: 1, slidesToScroll: 1 }, },
        ],
    };

    const bannerSettings = {
        dots: true,
        infinite: data?.length > 1,
        speed: 700,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: data?.length > 1,
        autoplaySpeed: 3000,
        arrows: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        swipe: true,
        adaptiveHeight: false,
    };

    const getProductImage = (product) => {
        const thumbnail = product?.thumbnail_full_url;

        if (product?.image) {
            return product.image;
        }

        if (typeof thumbnail === "string") {
            return thumbnail || noImage;
        }

        return thumbnail?.path || noImage;
    };

    const formatProductPrice = (price) => {
        const currency = localStorage.getItem("currency") || "₹";
        const currencyMap = {
            INR: "₹",
            USD: "$",
            EUR: "€",
            GBP: "£",
        };
        const symbol = currencyMap[currency?.toUpperCase?.()] || currency;
        const numberPrice = Number(price);
        const value = Number.isNaN(numberPrice)
            ? price ?? 0
            : numberPrice.toLocaleString("en-IN", { maximumFractionDigits: 2 });

        return `${symbol}${value}`;
    };

    const handleProductClick = (product) => {
        const slug = product?.slug;

        if (!slug) return;

        window.location.href = `https://shop.nabhiverse.com/product/${slug}`;
    };

    const handleSearch = useCallback(() => {
        const Userid = localStorage.getItem("Userid") || "0";
        if (Userid) {
            axios.post(
                `${BaseUrl}user_api/u_search_event.php`,
                {
                    uid: Userid,
                    keyword: input
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {
                    setSearchList(res?.data?.SearchData);
                })
                .catch((err) => {
                    console.error('Error:', err.message);
                })
        }

    }, [BaseUrl, input]);

    useEffect(() => {
        if (!input) return;
        handleSearch();
    }, [input, handleSearch]);

    useEffect(() => {
        window.scrollTo(0, 0);
        document.body.classList.add("desktop-home-active");
        // if (navigator.geolocation) {
        //     navigator.geolocation.getCurrentPosition(
        //         (position) => {
        setLocation({
            lat: STATIC_LOCATION?.lat,
            long: STATIC_LOCATION?.long,
        });
        //         })
        // }
        return () => document.body.classList.remove("desktop-home-active");
    }, []);

    const handleBanner = () => {
        const Userid = localStorage.getItem("Userid") || "0";

        if (Userid) {
            axios.get(`${BaseUrl}user_api/get_banner.php`)
                .then((res) => {
                    const bannerData = Array.isArray(res?.data?.data) ? res.data.data : [];

                    // filter only business type
                    const businessData = bannerData?.filter(item => item.banner_type === "user");

                    setData(businessData);
                })
                .catch((err) => {
                    setData([]);
                });
        }
    };

    const handleProducts = async () => {
        try {
            const guestRes = await axios.get("https://shop.nabhiverse.com/api/v1/get-guest-id");
            const guestId = guestRes?.data?.guest_id;

            if (!guestId) {
                setProducts([]);
                return;
            }

            const productRes = await axios.get("https://shop.nabhiverse.com/api/v1/products/latest", {
                params: {
                    limit: 20,
                    offset: 1,
                    guest_id: guestId,
                },
            });
            const latestProducts = Array.isArray(productRes?.data?.products) ? productRes.data.products : [];
            setProducts(latestProducts);
        } catch (err) {
            console.error("Product API Error:", err.message);
            setProducts([]);
        }
    };

    const handleHome = () => {
        const Userid = localStorage.getItem("Userid") || "0";

        if (Userid) {

            axios.post(
                `${BaseUrl}user_api/u_home_data.php`,
                {
                    uid: Userid,
                    lats: STATIC_LOCATION?.lat,
                    longs: STATIC_LOCATION?.long
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {
                    setLoading(false);
                    setApiRespData(res?.data?.HomeData);
                    localStorage.setItem("Tax", res.data.HomeData.Main_Data.tax);
                    localStorage.setItem("currency", res.data.HomeData.Main_Data.currency);
                    localStorage.setItem("Wallet", res.data.HomeData.wallet);
                })
                .catch((err) => {
                    console.error('Error:', err.message);
                });
        }
    };

    useEffect(() => {
        // if (location?.lat && location?.long) {
        handleHome();
        handleBanner();
        handleProducts();
        // }
    }, []);


    const handleFavorite = (e, eventId) => {
        e.stopPropagation();

        const Userid = localStorage.getItem("Userid") || "0";
        if (Userid) {
            axios.post(
                `${BaseUrl}user_api/u_fav.php`,
                {
                    uid: Userid,
                    eid: eventId
                },
                {
                    headers: {
                        'Content-Type': 'application/json',
                    },
                })
                .then((res) => {

                    if (res?.data?.ResponseCode === '200') {
                        handleHome();
                    }
                    const toastType = res?.data?.ResponseCode === '200' ? 'success' : 'error';
                    showTost(res?.data?.ResponseMsg, toastType);
                })
                .catch((err) => {
                    console.error('Error:', err.message);
                });
        } else {
            setIsLoginShow(true);
        }
    }

    const handleNavigate = (index, item) => {
        if (index === 0) {
            navoigate(`/event-details/${item?.slug}`);
            sessionStorage.setItem("Eventid", item?.event_id);
            sessionStorage.setItem("EventSlug", item?.slug);
        } else {
            navoigate("/event-category", { state: { EventId: item.id, CoverImg: item.cover_img, Title: item.title } });
        }
    }

    const handleShare = (eventId) => {
        const shareUrl = `https://nabhiverse.com/event-details/${eventId}`;
        const text = "Check out this event on Nabhiverse 👇";

        // ✅ If browser supports native share (mobile)
        if (navigator.share) {
            navigator.share({
                title: "Nabhiverse Event",
                text,
                url: shareUrl,
            }).catch(() => { });
        } else {
            // ✅ Fallback to WhatsApp
            const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(
                `${text} ${shareUrl}`
            )}`;
            window.open(whatsappUrl, "_blank");
        }
    };

    const desktopExploreItems = apiRespData?.Catlist?.length > 0
        ? apiRespData.Catlist.slice(0, 8).map((item) => ({
            ...item,
            title: item?.title || "Explore",
            subtitle: "Explore",
            image: item?.cat_img ? BaseUrl + item.cat_img : "",
            icon: MdOutlineApps,
        }))
        : DESKTOP_EXPLORE_FALLBACK;

    const desktopEventTabs = [
        { key: "all", label: "All" },
        { key: "latest_event", label: "Latest Event" },
        { key: "nearby_event", label: "Nearby Event" },
        { key: "this_month_event", label: "This Month Event" },
        { key: "upcoming_event", label: "Upcoming Event" },
    ];
    const desktopEventBuckets = {
        latest_event: apiRespData?.latest_event || [],
        nearby_event: apiRespData?.nearby_event || [],
        this_month_event: apiRespData?.this_month_event || [],
        upcoming_event: apiRespData?.upcoming_event || [],
    };
    const desktopEvents = [
        ...desktopEventBuckets.latest_event,
        ...desktopEventBuckets.nearby_event,
        ...desktopEventBuckets.this_month_event,
        ...desktopEventBuckets.upcoming_event,
    ];
    const selectedDesktopEvents = activeDesktopEventTab === "all"
        ? desktopEvents
        : desktopEventBuckets[activeDesktopEventTab] || [];
    const desktopEventItems = selectedDesktopEvents.length > 0
        ? selectedDesktopEvents.slice(0, 5)
        : activeDesktopEventTab === "all"
            ? DESKTOP_EVENTS_FALLBACK
            : [];
    const desktopProductItems = products?.length > 0
        ? products.slice(0, 6)
        : DESKTOP_PRODUCTS_FALLBACK;
    const desktopBannerItems = data?.length > 0
        ? data.map((item, index) => ({
            id: item?.id || index,
            image: item?.image,
            link: item?.banner_link || "#",
            type: "image",
        }))
        : DESKTOP_BANNER_FALLBACK;
    const desktopMenuItems = [
        { label: "Home", icon: HiOutlineHome, path: "/", active: true },
        { label: "Movies", icon: HiOutlineFilm },
        { label: "Events", icon: MdOutlineEvent },
        { label: "Sports", icon: MdOutlineSportsCricket },
        { label: "Games", icon: BsController },
        { label: "Shopping", icon: MdOutlineShoppingBag },
        { label: "Services", icon: MdOutlineApps },
        { label: "Offers", icon: MdOutlineLocalOffer },
        { label: "Bookings", icon: FaTicketAlt, path: "/booking" },
        { label: "Favorites", icon: FaHeart, path: "/favorite" },
        { label: "eWallet", icon: MdOutlineAccountBalanceWallet, path: "/wallet" },
        { label: "Forms", icon: FaWpforms, path: "/form-list" },
        { label: "Business", icon: FaBriefcase, path: "/business-user" },
        { label: "More", icon: MdOutlineApps },
    ];
    const mobileBottomMenuItems = [
        { label: "Home", icon: HiOutlineHome, path: "/" },
        { label: "Forms", icon: FaWpforms, path: "/form-list" },
        { label: "Business", icon: FaBriefcase, path: "/business-user" },
        { label: "More", icon: MdOutlineApps, action: () => setIsMobileDrawerOpen(true) },
    ];
    const handleDesktopMenuClick = (item) => {
        if (item.path) {
            navoigate(item.path);
            setIsMobileDrawerOpen(false);
        }
    };

    return (
        <div>
            <div className="nabhiverse_desktop_home">
                <aside className="desktop_home_sidebar">
                    <div className="desktop_home_logo">
                        <img src={logoWithName} alt="Nabhiverse" />
                    </div>
                    <nav className="desktop_home_nav">
                        {desktopMenuItems.map((item) => {
                            const Icon = item.icon;
                            return (
                                <button
                                    key={item.label}
                                    className={`desktop_home_nav_item ${item.active ? "active" : ""}`}
                                    type="button"
                                    onClick={() => handleDesktopMenuClick(item)}
                                >
                                    <Icon />
                                    <span>{item.label}</span>
                                </button>
                            );
                        })}
                    </nav>
                    <div className="desktop_home_star_box">
                        <FiStar />
                        <span>nabi star</span>
                        <strong>Your Stars 620</strong>
                        <button type="button">View Benefits</button>
                    </div>
                    <div className="desktop_home_help_box">
                        <FiHeadphones />
                        <span>Need Help?</span>
                        <p>24x7 Support</p>
                        <button type="button">Contact Us</button>
                    </div>
                </aside>

                <div
                    className={`mobile_menu_overlay ${isMobileDrawerOpen ? "show" : ""}`}
                    onClick={() => setIsMobileDrawerOpen(false)}
                ></div>
                <aside className={`mobile_menu_drawer ${isMobileDrawerOpen ? "show" : ""}`}>
                    <div className="mobile_drawer_head">
                        <img src={logoWithName} alt="Nabhiverse" />
                        <button type="button" onClick={() => setIsMobileDrawerOpen(false)}>×</button>
                    </div>
                    <div className="mobile_drawer_body">
                        <nav className="mobile_drawer_nav">
                            {desktopMenuItems.map((item) => {
                                const Icon = item.icon;
                                return (
                                    <button
                                        key={item.label}
                                        className={`desktop_home_nav_item ${item.active ? "active" : ""}`}
                                        type="button"
                                        onClick={() => handleDesktopMenuClick(item)}
                                    >
                                        <Icon />
                                        <span>{item.label}</span>
                                    </button>
                                );
                            })}
                        </nav>
                        <div className="desktop_home_star_box">
                            <FiStar />
                            <span>nabi star</span>
                            <strong>Your Stars 620</strong>
                            <button type="button">View Benefits</button>
                        </div>
                        <div className="desktop_home_help_box">
                            <FiHeadphones />
                            <span>Need Help?</span>
                            <p>24x7 Support</p>
                            <button type="button">Contact Us</button>
                        </div>
                    </div>
                </aside>

                <main className="desktop_home_main">
                    <header className="desktop_home_topbar">
                        <div className="mobile_header_logo">
                            <img src={logoWithName} alt="Nabhiverse" />
                        </div>
                        <div className="desktop_search_box">
                            <FiSearch />
                            <input
                                value={input || ""}
                                onChange={(e) => setInput(e.target.value)}
                                type="text"
                                placeholder="Search for apps, services, movies, events and more..."
                            />
                            {input && (
                                <div className="desktop_search_results">
                                    {searchList?.length > 0 ? searchList.slice(0, 5).map((item, index) => (
                                        <button key={item?.event_id || index} type="button" onClick={() => handleNavigate(0, item)}>
                                            <span>{item?.event_title}</span>
                                            <small>{item?.event_sdate}</small>
                                        </button>
                                    )) : (
                                        <p>Event Not Available</p>
                                    )}
                                </div>
                            )}
                        </div>
                        <div className="desktop_location"><FiMapPin /> Bengaluru</div>
                        <DesktopUserChip />
                        <button className="desktop_bell_btn" type="button">
                            <FiBell />
                            <span>3</span>
                        </button>
                        <div className="mobile_top_wallet_card">
                            <span>1 ANNA eWallet</span>
                            <strong>{formatProductPrice(1250)}</strong>
                            <button type="button" aria-label="Add money"><FiPlus /></button>
                        </div>
                    </header>

                    <section className="desktop_quick_actions">
                        {[
                            { label: "Scan & Pay", icon: BsQrCodeScan },
                            { label: "UPI Transfer", icon: MdOutlinePayments },
                            { label: "Add Money", icon: FiPlus },
                            { label: "BBPS", icon: MdOutlinePayments },
                            { label: "Pay Bills", icon: MdOutlinePayments },
                            { label: "Mobile Recharge", icon: MdOutlinePhoneAndroid },
                            { label: "Gift Cards", icon: HiOutlineGift },
                            { label: "More", icon: MdOutlineApps },
                        ].map((item) => {
                            const Icon = item.icon;
                            return (
                                <button key={item.label} type="button">
                                    <Icon />
                                    <span>{item.label}</span>
                                </button>
                            );
                        })}
                        <div className="desktop_wallet_card">
                            <span>1 ANNA eWallet</span>
                            <strong>{formatProductPrice(1250)}</strong>
                            <button type="button"><FiPlus /></button>
                        </div>
                    </section>

                    <section className="desktop_hero_section">
                        <Swiper
                            className="desktop_hero_swiper"
                            modules={[Autoplay, Navigation, Pagination]}
                            navigation={desktopBannerItems.length > 1}
                            pagination={{ clickable: true }}
                            loop={desktopBannerItems.length > 1}
                            autoplay={desktopBannerItems.length > 1 ? { delay: 3500, disableOnInteraction: false } : false}
                        >
                            {desktopBannerItems.map((banner) => (
                                <SwiperSlide key={banner.id}>
                                    {banner.type === "image" && banner.image ? (
                                        <div
                                            className="desktop_hero has_image"
                                            style={{ backgroundImage: `url(${banner.image})` }}
                                        >
                                            <Link className="desktop_hero_banner_link" to={banner.link || "#"} aria-label="Open banner" />
                                        </div>
                                    ) : (
                                        <div className="desktop_hero">
                                            <div className="desktop_hero_copy">
                                                <span>SUPER SAVER</span>
                                                <h1>WEEKEND BONANZA</h1>
                                                <p>Big offers across Nabhiverse!</p>
                                                <Link to="#">Explore Offers <FaArrowRightLong /></Link>
                                            </div>
                                            <div className="desktop_hero_visual">
                                                <div className="desktop_gift_stack">
                                                    <HiOutlineGift />
                                                </div>
                                                <div className="desktop_anna_coin">1 ANNA<br />eWallet</div>
                                                <div className="desktop_sport_ball"></div>
                                            </div>
                                            <div className="desktop_hero_offer">
                                                <span>UP TO</span>
                                                <strong>50%</strong>
                                                <p>OFF</p>
                                                <small>Limited Time Only!</small>
                                            </div>
                                        </div>
                                    )}
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </section>

                    <section className="desktop_home_section">
                        <div className="desktop_section_head">
                            <h2>Explore Nabhiverse</h2>
                            <button type="button">View All <FaArrowRightLong /></button>
                        </div>
                        <div className="desktop_explore_grid">
                            {desktopExploreItems.map((item, index) => {
                                const Icon = item.icon || MdOutlineApps;
                                return (
                                    <button
                                        key={item?.id || item?.title || index}
                                        type="button"
                                        className={`desktop_explore_card tone_${item.tone || "purple"}`}
                                        onClick={() => item?.id ? handleNavigate(1, item) : undefined}
                                    >
                                        {item.image ? <img src={item.image} alt="" /> : <Icon />}
                                        <strong>{item.title}</strong>
                                        <span>{item.subtitle}</span>
                                    </button>
                                );
                            })}
                        </div>
                    </section>

                    <section className="desktop_home_section">
                        <div className="desktop_section_head">
                            <h2>Offers Just For You</h2>
                            <button type="button">View All Offers <FaArrowRightLong /></button>
                        </div>
                        <div className="desktop_offer_grid">
                            {DESKTOP_OFFERS_FALLBACK.map((offer) => (
                                <div key={offer.title} className={`desktop_offer_card tone_${offer.tone}`}>
                                    <span>{offer.subtitle}</span>
                                    <h3>{offer.title}</h3>
                                    <p>Code: {offer.code}</p>
                                    <button type="button">{offer.action}</button>
                                </div>
                            ))}
                        </div>
                        <Swiper
                            className="desktop_offer_slider"
                            slidesPerView={1.5}
                            spaceBetween={10}
                            breakpoints={{
                                640: {
                                    slidesPerView: 2,
                                    spaceBetween: 10,
                                },
                            }}
                        >
                            {DESKTOP_OFFERS_FALLBACK.map((offer) => (
                                <SwiperSlide key={offer.title}>
                                    <div className={`desktop_offer_card tone_${offer.tone}`}>
                                        <span>{offer.subtitle}</span>
                                        <h3>{offer.title}</h3>
                                        <p>Code: {offer.code}</p>
                                        <button type="button">{offer.action}</button>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </section>

                    <section className="desktop_home_section">
                        <div className="desktop_section_head">
                            <h2>Events & Tickets</h2>
                            <div className="desktop_tabs">
                                {desktopEventTabs.map((tab) => (
                                    <button
                                        key={tab.key}
                                        className={activeDesktopEventTab === tab.key ? "active" : ""}
                                        type="button"
                                        onClick={() => setActiveDesktopEventTab(tab.key)}
                                    >
                                        {tab.label}
                                    </button>
                                ))}
                            </div>
                            <button type="button">View All <FaArrowRightLong /></button>
                        </div>
                        <div className="desktop_event_grid">
                            {desktopEventItems.length > 0 ? desktopEventItems.map((item, index) => (
                                <button
                                    key={item?.event_id || item?.event_title || index}
                                    type="button"
                                    className="desktop_event_card"
                                    onClick={() => item?.slug ? handleNavigate(0, item) : undefined}
                                >
                                    <div className="desktop_event_img">
                                        <img
                                            src={item?.event_img ? BaseUrl + item.event_img : item?.image || noImage}
                                            onError={(e) => {
                                                e.currentTarget.onerror = null;
                                                e.currentTarget.src = noImage;
                                            }}
                                            alt=""
                                        />
                                        <span>{item?.type || "EVENT"}</span>
                                    </div>
                                    <div>
                                        <strong>{item?.event_title || "Nabhiverse Event"}</strong>
                                        <p>{item?.event_sdate || "Book your slot"}</p>
                                        <small>{item?.event_place_name || "Nabhiverse"}</small>
                                        <span className="desktop_book_btn">Book Now</span>
                                    </div>
                                </button>
                            )) : (
                                <div className="desktop_event_empty">No events available</div>
                            )}
                        </div>
                    </section>

                    <section className="desktop_home_section">
                        <div className="desktop_section_head">
                            <h2>Shop From Eleven11 Cart</h2>
                            <button type="button">View All Products <FaArrowRightLong /></button>
                        </div>
                        <div className="desktop_product_grid">
                            {desktopProductItems.map((product, index) => (
                                <button
                                    key={product?.id || product?.slug || product?.name || index}
                                    type="button"
                                    className="desktop_product_card"
                                    onClick={() => product?.slug ? handleProductClick(product) : undefined}
                                >
                                    <img
                                        src={getProductImage(product)}
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = noImage;
                                        }}
                                        alt=""
                                    />
                                    <strong>{product?.name || "Product"}</strong>
                                    <span>{product?.unit || "Item"}</span>
                                    <p>{formatProductPrice(product?.unit_price)}</p>
                                    <small>Add</small>
                                </button>
                            ))}
                        </div>
                    </section>

                    <section className="desktop_home_section">
                        <div className="desktop_section_head">
                            <h2>Trending Videos</h2>
                            <button type="button">View All Videos <FaArrowRightLong /></button>
                        </div>
                        <div className="desktop_video_grid">
                            {DESKTOP_VIDEOS_FALLBACK.map((video) => (
                                <div key={video.title} className="desktop_video_card">
                                    <div className="desktop_play_icon">▶</div>
                                    <span>{video.time}</span>
                                    <strong>{video.title}</strong>
                                    <p>{video.subtitle}</p>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="desktop_rewards_row">
                        <div><FiStar /><span>Nabi Star Benefits</span><p>Earn Stars & unlock exclusive rewards!</p></div>
                        <div><FiStar /><span>Your Stars</span><strong>620</strong></div>
                        <div><HiOutlineGift /><span>Refer & Earn</span><p>Invite friends & earn rewards</p><button type="button">Refer Now</button></div>
                    </section>

                    <footer className="desktop_home_footer">
                        <img src={logoWithName} alt="Nabhiverse" />
                        <span><FiShield /> Fast & Secure Payments</span>
                        <span><FiRefreshCcw /> Easy Returns</span>
                        <span><FiHeadphones /> 24x7 Support</span>
                        <p>© 2026 Nabhiverse. All Rights Reserved.</p>
                    </footer>
                </main>

                <nav className="mobile_bottom_menu">
                    {mobileBottomMenuItems.map((item) => {
                        const Icon = item.icon;
                        return (
                            <button
                                key={item.label}
                                type="button"
                                onClick={() => item.action ? item.action() : navoigate(item.path)}
                            >
                                <Icon />
                                <span>{item.label}</span>
                            </button>
                        );
                    })}
                </nav>
            </div>
            <div className="width_container">
                <div className="dashbord">
                    {/* <div className="section_1">
                        <div className="box">
                            <h1 className="title">{t("Discover amazing event")}</h1>
                            <div className="input_box">
                                <GoSearch style={{ color: "white", fontSize: "20px" }} />
                                <input style={{ color: "white" }} value={input} onChange={(e) => setInput(e.target.value)} type="text" placeholder={t("Search here...")} />
                                {input && <div className="search_box overflow-hidden">
                                    {searchList?.length >= 1
                                        ? searchList?.map((item, index) => {
                                            return <div onClick={() => handleNavigate(0, item)} key={index} className="item_box">
                                                <img src={BaseUrl + item.event_img} alt="" />
                                                <div className="w-[100%] overflow-hidden">
                                                    <h4 className="font-bold whitespace-nowrap overflow-hidden overflow-ellipsis">{item.event_title}</h4>
                                                    <p className="max-_430_:whitespace-nowrap overflow-ellipsis"><GrLocation className="max-_430_:hidden" />{item.event_place_name}</p>
                                                    <p className="whitespace-nowrap overflow-ellipsis"><LuCalendar1 className="max-_430_:hidden" />{item.event_sdate}</p>
                                                </div>
                                            </div>
                                        })
                                        : <div className="h-[100%] w-[100%] flex items-center justify-center">
                                            <h1 className="font-bold">{t("Event Not Available !!")}</h1>
                                        </div>}
                                </div>}
                            </div>

                            <div className="review_box">
                                {!input && <div className="user_box">
                                    <img src={author1} alt="" style={{ zIndex: "40" }} />
                                    <img src={author2} alt="" style={{ zIndex: "30", marginLeft: "-10px" }} />
                                    <img src={author3} alt="" style={{ zIndex: "20", marginLeft: "-10px" }} />
                                    <img src={author4} alt="" style={{ zIndex: "10", marginLeft: "-10px" }} />
                                    <img src={author5} alt="" style={{ zIndex: "0", marginLeft: "-10px" }} />
                                </div>}
                                <div className="ms-[20px]">
                                    <p>⭐⭐⭐⭐⭐</p>
                                    <p style={{ color: "white", marginTop: "10px" }}>850+ {t("Reviews")}</p>
                                </div>
                            </div>
                        </div>
                    </div> */}

                    {data?.length > 0 && (
                        <div className="section_1 " style={{ height: "auto" }}>
                            <div className="banner_slider_wrap w-[100%]">
                                {data?.length > 1 ? (
                                    <Slider {...bannerSettings}>
                                        {data.map((item, index) => (
                                            <div key={item.id || index}>
                                                <Link to={item.banner_link ? item.banner_link : "#"} target="_blank" rel="noopener noreferrer">
                                                    <img src={item?.image} alt="" className="rounded-xl mb-4" style={{ width: "100%" }} />
                                                </Link>
                                            </div>
                                        ))}
                                    </Slider>
                                ) : (
                                    data.map((item, index) => (
                                        <div key={item.id || index}>
                                            <Link to={item.banner_link ? item.banner_link : "#"} target="_blank" rel="noopener noreferrer">
                                                <img src={item?.image} alt="" className="rounded-xl mb-4" style={{ width: "100%" }} />
                                            </Link>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>
                    )}

                    {apiRespData?.Catlist?.length > 0 && (
                    <div className="section_2">
                        <h1 className="title">{t("Browse by Category")}</h1>
                        <div className="category_box">
                            <div className="slider-container">
                                {apiRespData?.Catlist?.length > 1 ? (
                                    <Slider key={sliderKey} {...settings}>
                                        {apiRespData?.Catlist?.map((item, index) => {
                                            return <div key={index} onClick={() => handleNavigate(1, item)} className="item_box">
                                                <div className="cat_img">
                                                    <img src={BaseUrl + item.cat_img} width="40%" alt="" />
                                                </div>
                                                <h5 className="mt-[10px] text-[16px] font-bold text-center">{item.title}</h5>
                                            </div>
                                        })}
                                    </Slider>
                                ) : (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                                        {apiRespData?.Catlist?.map((item, index) => {
                                            return <div key={index} onClick={() => handleNavigate(1, item)} className="item_box">
                                                <div className="cat_img">
                                                    <img src={BaseUrl + item.cat_img} width="40%" alt="" />
                                                </div>
                                                <h5 className="mt-[10px] text-[16px] font-bold text-center">{item.title}</h5>
                                            </div>
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    )}

                    {products?.length > 0 && (
                        <div className="section_products">
                            <div style={{ justifyContent: "space-between" }} className="flex_box">
                                <h1 className="title">{t("Products")}</h1>
                            </div>
                            <div className="product_slider_wrap">
                                <Swiper
                                    className="products_swiper"
                                    grabCursor
                                    watchOverflow
                                    spaceBetween={16}
                                    slidesPerView={1.15}
                                    breakpoints={{
                                        430: { slidesPerView: 1.5 },
                                        580: { slidesPerView: 2.1 },
                                        770: { slidesPerView: 2.5 },
                                        1030: { slidesPerView: 3.4 },
                                        1305: { slidesPerView: 4 },
                                    }}
                                >
                                    {products.map((product) => (
                                        <SwiperSlide key={product?.id ?? product?.slug}>
                                            <div
                                                className="product_card"
                                                onClick={() => handleProductClick(product)}
                                            >
                                                <div className="product_img_box">
                                                    <img
                                                        src={getProductImage(product)}
                                                        onError={(e) => {
                                                            e.currentTarget.onerror = null;
                                                            e.currentTarget.src = noImage;
                                                        }}
                                                        alt={product?.name || "Product"}
                                                    />
                                                </div>
                                                <div className="product_detail_box">
                                                    <h4>{product?.name || "Product"}</h4>
                                                    <div className="product_meta">
                                                        <span>{product?.unit || "Item"}</span>
                                                        <p>{formatProductPrice(product?.unit_price)}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </SwiperSlide>
                                    ))}
                                </Swiper>
                            </div>
                        </div>
                    )}

                    {apiRespData?.latest_event?.length > 0 && (
                    <div className="section_3">
                        <div style={{ justifyContent: "space-between" }} className="flex_box">
                            <h1 className="title">{t("Latest Event")}</h1>
                            <div className="icon_box">
                                <img style={{ width: "20px", marginRight: "5px" }} src={fireimg} alt="FireImg" />
                                <h4 className="font-bold">{t("Just Dropped – Be the First to Book!")}</h4>
                            </div>
                        </div>
                        <div className="latest_event_slider_wrap">
                            <Swiper
                                className="latest_event_swiper"
                                grabCursor
                                watchOverflow
                                spaceBetween={16}
                                slidesPerView={1.05}
                                breakpoints={{
                                    580: { slidesPerView: 1.4 },
                                    770: { slidesPerView: 2.1 },
                                    1030: { slidesPerView: 2.8 },
                                    1305: { slidesPerView: 3.4 },
                                }}
                            >
                                {apiRespData?.latest_event?.map((item, index) => {
                                    return <SwiperSlide key={item?.event_id || index}>
                                        <div onClick={() => handleNavigate(0, item)} className="card_box">
                                            {(item?.self_host === "1" || item?.self_host === 1) && (
                                                <p
                                                    title="share"
                                                    className="selfhost_icon"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleShare(item.event_id);
                                                    }}
                                                >
                                                    <img src={selfhost} alt="" />
                                                </p>
                                            )}
                                            <p
                                                title="share"
                                                className="share_icon"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleShare(item.event_id);
                                                }}
                                            >
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#ffffff">
                                                    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7a3.27 3.27 0 0 0 0-1.39l7.02-4.11A2.99 2.99 0 1 0 14 5a3 3 0 0 0 .04.49L7.02 9.6a3 3 0 1 0 0 4.8l7.02 4.11A3 3 0 1 0 18 16.08z" />
                                                </svg>
                                            </p>
                                            <img
                                                src={item.event_img ? BaseUrl + item.event_img : noImage}
                                                onError={(e) => {
                                                    e.currentTarget.onerror = null; // prevent infinite loop
                                                    e.currentTarget.src = noImage;
                                                }}
                                                className="w-[100%] h-[100%] object-cover"
                                                alt="" />
                                            <div className="detail_box">
                                                <div className="title">{item.event_title}</div>
                                                <div style={{ gap: "10px" }} className="flex_box">
                                                    <div className="">
                                                        <div className="flex items-start gap-[8px]">
                                                            <LuCalendar1 style={{ fontSize: "20px" }} />
                                                            <p className="text-[15px]">{item.event_sdate}</p>
                                                        </div>

                                                        <div className="flex items-start gap-[8px] mt-2">
                                                            <GrLocation style={{ fontSize: "20px" }} />
                                                            <span className="text-[14px] overflow-hidden overflow-ellipsis" >{item.event_place_name}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </SwiperSlide>
                                })}
                            </Swiper>
                        </div>
                    </div>
                    )}

                    {apiRespData?.nearby_event?.length > 0 && (
                    <div className="section_4">
                        <div style={{ justifyContent: "space-between" }} className="flex_box">
                            <h1 className="title">{t("Nearby Event")}</h1>
                            <div className="icon_box">
                                <img style={{ width: "20px", marginRight: "5px" }} src={pinimg} alt="FireImg" />
                                <h4 className="font-bold">{t("Happening Around You – Don’t Miss Out!")}</h4>
                            </div>
                        </div>
                        <div style={{ marginTop: "20px" }}>
                            <div style={{ margin: "0 10px" }} className="slider-container">
                                {apiRespData?.nearby_event?.length > 1 ? (
                                    <Slider {...settings2}>
                                        {apiRespData?.nearby_event?.map((item, index) => {
                                            return <div key={index} onClick={() => handleNavigate(0, item)} className="card_box">
                                                <div className="img_box">
                                                    {(item?.self_host === "1" || item?.self_host === 1) && (
                                                        <p
                                                            title="share"
                                                            className="selfhost_icon"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleShare(item.event_id);
                                                            }}
                                                        >
                                                            <img src={selfhost} alt="" />
                                                        </p>
                                                    )}
                                                    <p
                                                        title="share"
                                                        className="share_icon"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleShare(item.event_id);
                                                        }}
                                                    >
                                                        {/* <img src={sharing} alt="" className="w-[20px] h-[20px]" /> */}
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#ffffff">
                                                            <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7a3.27 3.27 0 0 0 0-1.39l7.02-4.11A2.99 2.99 0 1 0 14 5a3 3 0 0 0 .04.49L7.02 9.6a3 3 0 1 0 0 4.8l7.02 4.11A3 3 0 1 0 18 16.08z" />
                                                        </svg>
                                                    </p>
                                                    {/* <img src={BaseUrl + item.event_img} className="w-[100%] h-[100%] object-cover" alt="" /> */}
                                                    <img
                                                        src={item.event_img ? BaseUrl + item.event_img : noImage}
                                                        onError={(e) => {
                                                            e.currentTarget.onerror = null; // prevent infinite loop
                                                            e.currentTarget.src = noImage;
                                                        }}
                                                        className="w-[100%] h-[100%] object-cover"
                                                        alt="event"
                                                    />
                                                </div>
                                                <div className="detail_box">
                                                    <div style={{ justifyContent: "space-between", marginBottom: "10px" }} className="flex_box">
                                                        <div className="trim">
                                                            <span>{item.event_title}</span>
                                                            <p>{item.event_place_name}</p>
                                                        </div>
                                                        {/* <div className="price_btn">{item.ticket_price}</div> */}
                                                    </div>
                                                    <p style={{ borderTop: "1px solid #f1f2f4", paddingTop: "10px", fontSize: "14px" }}>{item.event_sdate}</p>
                                                </div>
                                                <div style={{ justifyContent: "space-between" }} className="detail_box flex_box">
                                                    <div className="flex_box">
                                                        <p style={{ fontSize: "14px", color: "gray" }}>{t("View Details")}</p>
                                                        <FaArrowRightLong style={{ fontSize: "14px", color: "gray" }} />
                                                    </div>
                                                    <div onClick={(e) => handleFavorite(e, item.event_id)} className="">
                                                        {item.IS_BOOKMARK === 0
                                                            ? <svg fill="#d2a347" width="30" height="30" viewBox="0 0 16 16">
                                                                <path d="M11 2.112c2.393 0 4.333 1.94 4.333 4.333 0 4.245-4.647 6.59-6.542 7.37-.511.21-1.071.21-1.582 0-1.896-.78-6.543-3.124-6.543-7.37 0-2.393 1.94-4.333 4.333-4.333a4.32 4.32 0 0 1 3 1.206 4.32 4.32 0 0 1 3-1.206zm0 1.333c-.807 0-1.537.317-2.077.835l-.462.443c-.258.248-.665.248-.923 0l-.462-.443c-.54-.518-1.27-.835-2.077-.835a3 3 0 0 0-3 3c0 1.588.86 2.9 2.101 3.978s2.728 1.794 3.615 2.159a.73.73 0 0 0 .567 0c.888-.365 2.373-1.08 3.615-2.159S14 8.034 14 6.445a3 3 0 0 0-3-3z"></path>
                                                            </svg>
                                                            : <svg fill="#d2a347" width="30" height="30" viewBox="0 0 16 16">
                                                                <path d="M8 3.339a4.32 4.32 0 0 0-3-1.206c-2.393 0-4.333 1.94-4.333 4.333 0 4.246 4.647 6.59 6.543 7.37.511.21 1.071.21 1.582 0 1.896-.78 6.543-3.124 6.543-7.37 0-2.393-1.94-4.333-4.333-4.333a4.32 4.32 0 0 0-3 1.206z"></path>
                                                            </svg>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        })}
                                    </Slider>
                                ) : (
                                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                                        {apiRespData?.nearby_event?.map((item, index) => {
                                            return <div key={index} onClick={() => handleNavigate(0, item)} className="card_box col">
                                                <div className="img_box">
                                                    {(item?.self_host === "1" || item?.self_host === 1) && (
                                                        <p
                                                            title="share"
                                                            className="selfhost_icon"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                handleShare(item.event_id);
                                                            }}
                                                        >
                                                            <img src={selfhost} alt="" />
                                                        </p>
                                                    )}
                                                    <p
                                                        title="share"
                                                        className="share_icon"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleShare(item.event_id);
                                                        }}
                                                    >
                                                        {/* <img src={sharing} alt="" className="w-[20px] h-[20px]" /> */}
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#ffffff">
                                                            <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7a3.27 3.27 0 0 0 0-1.39l7.02-4.11A2.99 2.99 0 1 0 14 5a3 3 0 0 0 .04.49L7.02 9.6a3 3 0 1 0 0 4.8l7.02 4.11A3 3 0 1 0 18 16.08z" />
                                                        </svg>
                                                    </p>
                                                    <img src={item.event_img ? BaseUrl + item.event_img : noImage}
                                                        onError={(e) => {
                                                            e.currentTarget.onerror = null; // prevent infinite loop
                                                            e.currentTarget.src = noImage;
                                                        }}
                                                        className="w-[100%] h-[100%] object-cover"
                                                        alt="" />
                                                </div>
                                                <div className="detail_box">
                                                    <div style={{ justifyContent: "space-between", marginBottom: "10px" }} className="flex_box">
                                                        <div className="trim">
                                                            <span>{item.event_title}</span>
                                                            <p>{item.event_place_name}</p>
                                                        </div>
                                                        {/* <div className="price_btn">{item.ticket_price}</div> */}
                                                    </div>
                                                    <p style={{ borderTop: "1px solid #f1f2f4", paddingTop: "10px", fontSize: "14px" }}>{item.event_sdate}</p>
                                                </div>
                                                <div style={{ justifyContent: "space-between" }} className="detail_box flex_box">
                                                    <div className="flex_box">
                                                        <p style={{ fontSize: "14px", color: "gray" }}>{t("View Details")}</p>
                                                        <FaArrowRightLong style={{ fontSize: "14px", color: "gray" }} />
                                                    </div>
                                                    <div onClick={(e) => handleFavorite(e, item.event_id)} className="">
                                                        {item.IS_BOOKMARK === 0
                                                            ? <svg fill="#d2a347" width="30" height="30" viewBox="0 0 16 16">
                                                                <path d="M11 2.112c2.393 0 4.333 1.94 4.333 4.333 0 4.245-4.647 6.59-6.542 7.37-.511.21-1.071.21-1.582 0-1.896-.78-6.543-3.124-6.543-7.37 0-2.393 1.94-4.333 4.333-4.333a4.32 4.32 0 0 1 3 1.206 4.32 4.32 0 0 1 3-1.206zm0 1.333c-.807 0-1.537.317-2.077.835l-.462.443c-.258.248-.665.248-.923 0l-.462-.443c-.54-.518-1.27-.835-2.077-.835a3 3 0 0 0-3 3c0 1.588.86 2.9 2.101 3.978s2.728 1.794 3.615 2.159a.73.73 0 0 0 .567 0c.888-.365 2.373-1.08 3.615-2.159S14 8.034 14 6.445a3 3 0 0 0-3-3z"></path>
                                                            </svg>
                                                            : <svg fill="#d2a347" width="30" height="30" viewBox="0 0 16 16">
                                                                <path d="M8 3.339a4.32 4.32 0 0 0-3-1.206c-2.393 0-4.333 1.94-4.333 4.333 0 4.246 4.647 6.59 6.543 7.37.511.21 1.071.21 1.582 0 1.896-.78 6.543-3.124 6.543-7.37 0-2.393-1.94-4.333-4.333-4.333a4.32 4.32 0 0 0-3 1.206z"></path>
                                                            </svg>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                        })}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    )}

                    {apiRespData?.this_month_event?.length > 0 && (
                    <div className="section_5">
                        <div style={{ justifyContent: "space-between" }} className="flex_box">
                            <h1 className="title">{t("Monthly Event")}</h1>
                            <div className="icon_box">
                                <img style={{ width: "20px", marginRight: "5px" }} src={calendarimg} alt="FireImg" />
                                <h4 className="font-bold">{t("This Month’s Top Picks – Plan Your Fun!")}</h4>
                            </div>
                        </div>
                        <div style={{ marginTop: "20px", flexWrap: "wrap" }} className="flex_box">
                            {apiRespData?.this_month_event?.map((item, index) => {
                                return <div key={index} onClick={() => handleNavigate(0, item)} className="card_box">
                                    <div className="img_box">
                                        {(item?.self_host === "1" || item?.self_host === 1) && (
                                            <p
                                                title="share"
                                                className="selfhost_icon"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleShare(item.event_id);
                                                }}
                                            >
                                                <img src={selfhost} alt="" />
                                            </p>
                                        )}
                                        <p
                                            title="share"
                                            className="share_icon"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleShare(item.event_id);
                                            }}
                                        >
                                            {/* <img src={sharing} alt="" className="w-[20px] h-[20px]" /> */}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#ffffff">
                                                <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7a3.27 3.27 0 0 0 0-1.39l7.02-4.11A2.99 2.99 0 1 0 14 5a3 3 0 0 0 .04.49L7.02 9.6a3 3 0 1 0 0 4.8l7.02 4.11A3 3 0 1 0 18 16.08z" />
                                            </svg>
                                        </p>
                                        <img
                                            src={item.event_img ? BaseUrl + item.event_img : noImage}
                                            onError={(e) => {
                                                e.currentTarget.onerror = null; // prevent infinite loop
                                                e.currentTarget.src = noImage;
                                            }}
                                            className="w-[100%] h-[100%] object-cover"
                                            alt="" />
                                    </div>
                                    <div style={{ padding: "10px" }}>
                                        <div style={{ paddingBottom: "10px", lineHeight: "20px" }}>
                                            <h4 className="font-bold">{item.event_title}</h4>
                                            <p style={{ fontSize: "14px" }}>{item.event_place_name}</p>
                                            <span style={{ fontSize: "14px", color: "gray" }}>{item.event_sdate}</span>
                                        </div>
                                        <div style={{ borderTop: "1px solid #f1f2f4", paddingTop: "15px", cursor: "pointer", justifyContent: "space-between" }} className="flex_box">
                                            <div className="flex_box">
                                                <p style={{ fontSize: "14px", color: "gray" }}>{t("View Details")}</p>
                                                <FaArrowRightLong style={{ fontSize: "14px", color: "gray" }} />
                                            </div>
                                            <div onClick={(e) => handleFavorite(e, item.event_id)} className="">
                                                {item.IS_BOOKMARK === 0
                                                    ? <svg fill="#d2a347" width="30" height="30" viewBox="0 0 16 16">
                                                        <path d="M11 2.112c2.393 0 4.333 1.94 4.333 4.333 0 4.245-4.647 6.59-6.542 7.37-.511.21-1.071.21-1.582 0-1.896-.78-6.543-3.124-6.543-7.37 0-2.393 1.94-4.333 4.333-4.333a4.32 4.32 0 0 1 3 1.206 4.32 4.32 0 0 1 3-1.206zm0 1.333c-.807 0-1.537.317-2.077.835l-.462.443c-.258.248-.665.248-.923 0l-.462-.443c-.54-.518-1.27-.835-2.077-.835a3 3 0 0 0-3 3c0 1.588.86 2.9 2.101 3.978s2.728 1.794 3.615 2.159a.73.73 0 0 0 .567 0c.888-.365 2.373-1.08 3.615-2.159S14 8.034 14 6.445a3 3 0 0 0-3-3z"></path>
                                                    </svg>
                                                    : <svg fill="#d2a347" width="30" height="30" viewBox="0 0 16 16">
                                                        <path d="M8 3.339a4.32 4.32 0 0 0-3-1.206c-2.393 0-4.333 1.94-4.333 4.333 0 4.246 4.647 6.59 6.543 7.37.511.21 1.071.21 1.582 0 1.896-.78 6.543-3.124 6.543-7.37 0-2.393-1.94-4.333-4.333-4.333a4.32 4.32 0 0 0-3 1.206z"></path>
                                                    </svg>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    )}

                    {apiRespData?.upcoming_event?.length > 0 && (
                    <div className="section_6">
                        <div style={{ justifyContent: "space-between" }} className="flex_box">
                            <h1 className="title">{t("Upcoming Event")}</h1>
                            <div className="icon_box">
                                <img style={{ width: "20px", marginRight: "5px" }} src={deadlineimg} alt="FireImg" />
                                <h4 className="font-bold">{t("Coming Soon – Save Your Spot Early!")}</h4>
                            </div>
                        </div>
                        <div style={{ flexWrap: "wrap", marginTop: "20px" }} className="flex_box">
                            {apiRespData?.upcoming_event?.map((item, index) => {
                                return (
                                    <div key={index} onClick={() => handleNavigate(0, item)} className="card_box">
                                        <div div className="img_box" >
                                            {(item?.self_host === "1" || item?.self_host === 1) && (
                                                <p
                                                    title="share"
                                                    className="selfhost_icon"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        handleShare(item.event_id);
                                                    }}
                                                >
                                                    <img src={selfhost} alt="" />
                                                </p>
                                            )}
                                            <p
                                                title="share"
                                                className="share_icon"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    handleShare(item.event_id);
                                                }}
                                            >
                                                {/* <img src={sharing} alt="" className="w-[20px] h-[20px]" /> */}
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#ffffff">
                                                    <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7a3.27 3.27 0 0 0 0-1.39l7.02-4.11A2.99 2.99 0 1 0 14 5a3 3 0 0 0 .04.49L7.02 9.6a3 3 0 1 0 0 4.8l7.02 4.11A3 3 0 1 0 18 16.08z" />
                                                </svg>
                                            </p>
                                            <img
                                                src={item.event_img ? BaseUrl + item.event_img : noImage}
                                                onError={(e) => {
                                                    e.currentTarget.onerror = null; // prevent infinite loop
                                                    e.currentTarget.src = noImage;
                                                }}
                                                className="w-[100%] h-[100%] object-cover"
                                                alt="" />
                                        </div>
                                        <div style={{ padding: "10px" }}>
                                            <div className="">
                                                <div style={{ justifyContent: "space-between", marginBottom: "15px" }} className="flex_box">
                                                    <div className="trim">
                                                        <span>{item.event_title}</span>
                                                        <p>{item.event_place_name}</p>
                                                    </div>
                                                    {/* <div className="price_btn">{item.ticket_price}</div> */}
                                                </div>
                                                <div className="flex_box max-_770_:flex-wrap max-_1025_:flex-nowrap max-_1305_:flex-wrap mb-[10px] justify-between">
                                                    <h5 className="text-gray-500 text-[14px]">{item.event_sdate}</h5>
                                                    <div className="detail_btn">{t("View Details")}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    )}

                </div>
            </div >

            {loading && <Loading />}

            {input && <div className="overlay" onClick={() => setInput("")}></div>}


        </div >
    )
}

export default Dashboard
/* jshint ignore:end */
